/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/camelcase */
import React, { useContext } from 'react';
import CustomButton from '../../../../shared/forms/CustomButton';
import CustomInput from '../../../../shared/forms/CustomInput';
import AppContext from '../../../../../../context/shared/AppContext';
import Label from '../../../../shared/forms/Label';
import useFetch from '../../../../../../hooks/shared/custom/data/useFetch';
import { GET_BASESTATIONS_URL } from '../../../../../../services/api/shared/BasestationsUrl';
import CustomDropdownOption from '../../../../shared/forms/CustomDropdownOption';

const AddPublicIpAllcation = () => {
  const { loadingForm, onChange, formValue, onSubmit } = useContext(AppContext);
  const { data } = useFetch(`${GET_BASESTATIONS_URL}`);
  const { basestation_name, active, host, networks, public_ip_block, assigned_public_ip } = formValue;
  const submitForm = () => {
    return (
      basestation_name.length > 0 &&
      active.length > 0 &&
      host.length > 0 &&
      networks.length > 0 &&
      public_ip_block.length > 0 &&
      assigned_public_ip.length > 0
    );
  };
  return (
    <div id="add-access-point" className="modal fade mt-5" role="dialog">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header shadow">
            <h4 className="modal-title update_asset">Public Ip</h4>
            <button type="button" className="btn btn-outline-info btn-circle btn-close" data-dismiss="modal">
              x
            </button>
          </div>
          <div className="modal-body detail mb-4 p-0">
            <form
              className="col-md-12 p-0"
              onSubmit={(e) => {
                e.preventDefault();
                onSubmit();
              }}
            >
              <div className="d-flex">
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="Site Name" />
                  <select
                    className="form-control border border-info p-2"
                    id="class"
                    name="basestation_name"
                    style={{ borderRadius: '0' }}
                    onChange={onChange}
                  >
                    <option>--Basestation--</option>
                    {data.map((basestation) => {
                      return <CustomDropdownOption value={basestation.name} name={basestation.name} />;
                    })}
                  </select>
                </div>
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="Active" />

                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="active"
                    value={active}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="enter active"
                    type="text"
                    id="customerEmail"
                  />
                </div>
              </div>

              <div className="d-flex">
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="Host" />

                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="host"
                    value={host}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="enter host"
                    type="text"
                    id="customerEmail"
                  />
                </div>
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="Networks" />
                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="networks"
                    value={networks}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="enter 192.39.33.2"
                    type="text"
                    id="customerEmail"
                  />
                </div>
              </div>
              <div className="d-flex">
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="public ip block" />
                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="public_ip_block"
                    value={public_ip_block}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="enter 152.3.4.2"
                    type="text"
                    id="customerEmail"
                  />
                </div>

                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="Assigned Public Ip" />

                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="assigned_public_ip"
                    value={assigned_public_ip}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="enter assigned public ip"
                    type="text"
                    id="customerEmail"
                  />
                </div>
              </div>

              <div className="text-center mt-3">
                {loadingForm ? (
                  <CustomButton classname="btn btn-green px-3" name="Adding" disabled={loadingForm} />
                ) : (
                  <CustomButton classname="btn btn-green px-3" name="Add" disabled={!submitForm()} />
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPublicIpAllcation;
